import { createSelector } from 'reselect';
import { addBestsellersOnGridPagesSelector } from 'selectors/testTarget/offers/addBestsellersOnGridPages/addBestsellersOnGridPagesSelector';

const showSelector = createSelector(addBestsellersOnGridPagesSelector, addBestsellersOnGridPages => !!addBestsellersOnGridPages.show);

export { showSelector };
